import { List, Create, Edit, CreateOfficer, LedgerBarcode, GuestBarcode } from "../Components/index.js";

export default [
    {
        path: "/store/ledger/list",
        component: List,
        name: "store.account.ledger.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/ledger/create",
        component: Create,
        name: "store.account.ledger.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/ledger/create-officer",
        component: CreateOfficer,
        name: "store.account.ledger.create.officer",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/ledger/:id/edit",
        component: Edit,
        name: "store.account.ledger.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/ledger-barcode",
        component: LedgerBarcode,
        name: "store.ledger.barcode",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/store/ledger-guest-barcode",
        component: GuestBarcode,
        name: "store.ledger.guest.barcode",
        meta: {
            requiresAuth: true,
        },
    },
    // { path: '/store/ledger/item/view', component: View, name: 'store.account.ledger.view' ,
];
